import React from 'react'
import { useSearchParams } from 'react-router-dom'

export default function Footer() {
  const [searchParams] = useSearchParams()

  const exportUrl = React.useMemo(() => {
    const { t, o, f } = Object.fromEntries(searchParams) as { t?: string; o?: string; f?: string }
    return (
      'export/latest-filings?' +
      new URLSearchParams({
        t: t ?? '',
        ...(f && { f }),
        ...(o && { o }),
      })
    )
  }, [searchParams])

  return (
    <div className="flex justify-end text-2xs text-muted-2">
      <a
        href={exportUrl}
        className="tab-link"
        onClick={() => {
          window.gtag && window.gtag('event', 'download', { event_category: 'export' })
        }}
      >
        export
      </a>
    </div>
  )
}
